import React from 'react';
import PropTypes from 'prop-types';
import NumberFormatter from '../../NumberFormatter';
import style from '@src/js/Style';

const config = {
    pixel: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
};
export default class ImageRange extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            src: config.pixel,
            value: null,
        };
        
        this.nodes = {
            input: null,
        };

        if (props.items != undefined)
            this.items = props.items.map((item) => ({ src: item.src, min: NumberFormatter.parse(item.min).toFloat() }));

        this.onInputChange = this.onInputChange.bind(this);
    }
    
    static get propTypes() {

        return {
            items: PropTypes.array,
            value: PropTypes.number,
            bindToName: PropTypes.string,
            alt: PropTypes.string,
            className: PropTypes.string,
        };
    }

    componentDidMount() {

        if (this.props.bindToName) {

            this.nodes.input = document.querySelector(`[name="${this.props.bindToName}"]`);
            if (this.nodes.input) {

                this.nodes.input.addEventListener('input', this.onInputChange);
                // trigger event
            }
            else {

                throw new Error(`Can't find input with name ${this.props.bindToName}`);
            }
        }
    }

    componentWillUnmount() {

        if (this.nodes.input) {
            
            this.nodes.input.removeEventListener('input', this.onInputChange);
            this.nodes.input = null;
        }
    }

    render() {

        const classes = [style('max-w-full')];

        if (this.props.className != undefined)
            classes.push(this.props.className);

        return <img
            className={ classes.join(' ') }
            alt={ this.props.alt }
            src={ this.findImageSource(this.state.value ?? this.props.value) } />
    }

    findImageSource(value) {

        const
            defaultImage = this.props.items[0] ?? config.pixel,
            items = (this.items != undefined) ? Array.from(this.items).slice(1) : [];

        let src = defaultImage.src;
        items.forEach((item) => {

            if (item.min <= value)
                src = item.src;
        });

        return src;
    }

    onInputChange() {

        if (this.items != undefined)
            this.setState({ value: NumberFormatter.parse(this.nodes.input.value).toFloat() });
    }
}